module.exports = __webpack_public_path__ + "static/img/YKK.355d6cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/YKK.png
// module id = nMVy
// module chunks = 34